import { frontendURL } from '../../../helper/URLHelper';
import DealBoardIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/deal-board'),
    component: DealBoardIndex,
    name: 'deal_board_index',
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
